<template>
    <div>
        <footer class="w-100 d-inline-block 
        footer-bg">
        <!-- <div class="fixed-call-btn position-relative d-xl-inline-block d-none">
            <a class="text-white" href="javascript:void(0)" @click="openCall">
                <img src="@/assets/images/call-icon.svg" alt="picture">
            </a>
        </div> -->
        <!-- <div class="fixed-call-btn-2 
        position-relative d-xl-inline-block d-none">
            <a class="text-white" href="javascript:void(0)" @click="openWhatsApp">
                <i class="fa fa-whatsapp text-size-24 text-full-24" aria-hidden="true"></i>
            </a>
        </div> -->
            <div class="container autoContent">
                <div class="row margin-top4 margin-xl-bottom4">
                    <div class="col-xl-2 col-12 
                    col-sm-3 col-md-3 col-lg-2">
                        <div class="footer-logo w-100 d-inline-block">
                            <router-link to="/">
                                <img src="@/assets/images/footer-logo.svg" alt="picture">
                            </router-link>
                        </div>
                    </div>
                    <div class="col-xl-2 col-12 mt-xl-0 mt-4 col-sm-4 mt-sm-0 col-md-4 col-lg-2 d-xl-block d-none d-md-block d-sm-block d-lg-block">
                        <div class="w-100 d-inline-block padding-bottom-2">
                            <span class="text-white fw-bold text-size-15 spacing-2 family-guy text-full-15">Links
                            </span>
                        </div>
                        <ul class="w-100 d-inline-block ps-0 footer-services">
                            <li class="d-inline-block padding-bottom-1 w-100">
                                <a class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" href="javascript:void(0)">
                                    Shop
                                </a>
                            </li>
                            <li class="d-inline-block padding-bottom-1 w-100">
                                <router-link class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" to="/blog/" exact-active-class="active-link">
                                    Blog
                                </router-link>
                            </li>
                            <li class="d-inline-block padding-bottom-1 w-100">
                                <router-link class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" to="/about-us" exact-active-class="active-link">
                                    About Us
                                </router-link>
                            </li>
                            <li class="d-inline-block padding-bottom-1 w-100">
                                <router-link class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" to="/contact-us" exact-active-class="active-link">
                                    Contact Us
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-xl-2 col-6 
                    col-sm-4 col-md-4 col-lg-2 mt-xl-0 mt-4 mt-sm-0">
                        <div class="w-100 d-inline-block 
                        padding-bottom-2">
                            <span class="text-white fw-bold text-size-15 spacing-2 family-guy text-full-15">Services
                            </span>
                        </div>
                        <ul class="w-100 d-inline-block ps-0 footer-services">
                            <li class="d-inline-block padding-bottom-1 w-100">
                                <router-link class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" to="/services/mobile-dog-grooming-dubai-pet-groomer/" exact-active-class="active-link">
                                    Dog Grooming
                                </router-link>
                            </li>
                            <li class="d-inline-block padding-bottom-1 w-100">
                                <router-link class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" to="/services/mobile-cat-grooming-service-dubai/" exact-active-class="active-link">
                                    Cat Grooming
                                </router-link>
                            </li>
                            <li class="d-inline-block padding-bottom-1 w-100">
                                <router-link class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" to="/services/bird-grooming-services-dubai-pet-groomer/" exact-active-class="active-link">
                                    Bird Grooming
                                </router-link>
                            </li>
                            <li class="d-inline-block padding-bottom-1 w-100">
                                <router-link class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" to="/services/rabbit-grooming-dubai-mobile-pet-groomer/" exact-active-class="active-link">
                                    Rabbit Grooming
                                </router-link>
                            </li>
                            <li class="d-xl-inline-none d-block d-md-none padding-bottom-1 w-100">
                                <router-link class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" to="/blog/" exact-active-class="active-link">
                                    Blog
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-xl-3 col-6 
                    col-sm-4 col-md-4 col-lg-2 ps-xl-5 mt-4 mt-xl-0 mt-md-0">
                        <div class="w-100 d-inline-block 
                        padding-bottom-2">
                            <span class="text-white fw-bold text-size-15 spacing-2 family-guy text-full-15">Social Media
                            </span>
                        </div>
                        <!-- <ul class="w-100 d-inline-block ps-0 footer-services">
                            <li class="d-inline-block padding-bottom-2 w-100">
                                <a class="text-size-13 text-white d-inline-block inter-regular-family text-full-12" href="javascript:void(0)">
                                    <span class="d-inline-block text-center rounded-5 
                                    me-2 facebook-icon">
                                        <i aria-hidden="true" class="fa fa-facebook"></i>
                                    </span>
                                    Facebook
                                </a>
                            </li>
                            <li class="d-inline-block padding-bottom-2 w-100">
                                <a class="text-size-13 text-white d-inline-block inter-regular-family text-full-12" href="javascript:void(0)">
                                    <span class="d-inline-block text-center rounded-5 
                                    me-2 instagram-icon">
                                        <i aria-hidden="true" class="fa fa-instagram"></i>
                                    </span>
                                    Instagram
                                </a>
                            </li>
                            <li class="d-inline-block padding-bottom-2 w-100">
                                <a class="text-size-13 text-white d-inline-block inter-regular-family text-full-12" href="javascript:void(0)">
                                    <span class="d-inline-block text-center rounded-5 
                                    me-2 twitter-icon">
                                       <i aria-hidden="true" class="fa fa-twitter margin-top-1"></i> 
                                    </span>
                                    Twitter
                                </a>
                            </li>
                        </ul> -->
                        <ul class="w-100 d-inline-block ps-0 footer-services">
                            <li class="d-inline-block padding-bottom-2 w-100">
                                <a class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" href="https://www.facebook.com/dubaipetsgroomer/" target="_blank">
                                    <span class="d-inline-block text-center rounded-5 me-2 facebook-icon">
                                        <i aria-hidden="true" class="fa fa-facebook"></i>
                                    </span>
                                    Facebook
                                </a>
                            </li>
                            <li class="d-inline-block padding-bottom-2 w-100">
                                <a class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" href="https://www.instagram.com/dubaipetsgroomer/" target="_blank">
                                    <span class="d-inline-block text-center rounded-5 me-2 instagram-icon">
                                        <i aria-hidden="true" class="fa fa-instagram"></i>
                                    </span>
                                    Instagram
                                </a>
                            </li>
                            <li class="d-inline-block padding-bottom-2 w-100">
                                <a class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" href="https://www.twitter.com/dubaipetsgroomer/" target="_blank">
                                    <span class="d-inline-block text-center rounded-5 me-2 twitter-icon">
                                        <i aria-hidden="true" class="fa fa-twitter margin-top-1"></i> 
                                    </span>
                                    Twitter
                                </a>
                            </li>
                        </ul>

                    </div>
                    <div class="col-xl-3 col-12 
                    col-sm-8 col-md-8 col-lg-4">
                        <div class="w-100 d-inline-block 
                        padding-bottom-2">
                            <span class="text-white fw-bold text-size-15 spacing-2 family-guy text-full-15">Contact
                            </span>
                        </div>
                        <!-- <ul class="w-100 d-inline-block ps-0 footer-services">
                            <li class="d-inline-block padding-bottom-2 w-100">
                                <a class="text-size-13 text-white d-inline-block inter-regular-family text-full-12" href="javascript:void(0)">
                                    <span class="d-inline-block text-center rounded-5 
                                    me-2 call-icon">
                                        <i class="fa fa-phone phone-icon" aria-hidden="true">
                                        </i>
                                    </span>
                                    +971 5228 09076
                                </a>
                            </li>
                            <li class="d-inline-block padding-bottom-2 w-100">
                                <a class="text-size-13 text-white d-inline-block inter-regular-family text-full-12" href="javascript:void(0)">
                                    <span class="d-inline-block text-center rounded-5 
                                    me-2 call-icon">
                                        <i class="fa fa-envelope margin-top-1" aria-hidden="true">
                                        </i>
                                    </span>
                                    dubaipetsgroomer@gmail.com
                                </a>
                            </li>
                            <li class="d-inline-block padding-bottom-2 w-100">
                                <a class="text-size-13 text-white d-inline-block inter-regular-family text-full-12" href="javascript:void(0)">
                                    <span class="d-inline-block text-center rounded-5 
                                    me-2 call-icon">
                                       <i class="fa fa-map-marker margin-top-1" aria-hidden="true"></i>
                                    </span>
                                    Dubai Pets Groomer
                                </a>
                            </li>
                        </ul> -->
                        <ul class="w-100 d-inline-block ps-0 footer-services">
                            <li class="d-inline-block padding-bottom-2 w-100">
                                <a class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" href="javascript:void(0)" @click="openCall">
                                    <span class="d-inline-block text-center rounded-5 me-2 call-icon">
                                        <i class="fa fa-phone phone-icon" aria-hidden="true"></i>
                                    </span>
                                    +971 5228 09076
                                </a>
                            </li>
                            <li class="d-inline-block padding-bottom-2 w-100">
                                <a class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" href="mailto:dubaipetsgroomer@gmail.com">
                                    <span class="d-inline-block text-center rounded-5 me-2 call-icon">
                                        <i class="fa fa-envelope margin-top-1" aria-hidden="true"></i>
                                    </span>
                                    dubaipetsgroomer@gmail.com
                                </a>
                            </li>
                            <li class="d-inline-block padding-bottom-2 w-100">
                                <a class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" href="https://www.google.com/maps/place/Dubai+Pets+Groomer+-+Best+pets+Grooming/@25.2048493,55.2517284,15z/data=!4m10!1m2!2m1!1sDubai+Pets+Groomer+-+Best+pets+Grooming!3m6!1s0x3e5f43dc588c97e5:0x13806c0bee3449ef!8m2!3d25.2048493!4d55.2707828!15sCidEdWJhaSBQZXRzIEdyb29tZXIgLSBCZXN0IHBldHMgR3Jvb21pbmeSAQtwZXRfZ3Jvb21lcuABAA!16s%2Fg%2F11v3q6xnct?entry=ttu" target="_blank">
                                    <span class="d-inline-block text-center rounded-5 me-2 call-icon">
                                        <i class="fa fa-map-marker margin-top-1" aria-hidden="true"></i>
                                    </span>
                                    Dubai Pets Groomer
                                </a>
                            </li>
                        </ul>

                    </div>
                </div>
                <div class="row margin-xl-top-3 margin-bottom-3">
                    <div class="col-xl-3 col-12 order-xl-1 order-3 mt-xl-0 mt-3 col-sm-6 col-md-6 col-lg-6 mb-xl-0 mb-2">
                        <div class="w-100 
                        d-inline-block text-xs-center text-sm-center text-md-center mb-xl-0 mb-5">
                            <p class="text-size-14 text-white mb-xl-0 mb-5 medium-family 
                            text-full-11">
                                Copyright © 2025. All rights reserved
                            </p>
                        </div>
                    </div>
                    <div class="col-xl-3 col-12 order-xl-2 order-2 mt-xl-0 mt-3 col-sm-6 col-md-6 col-lg-6">
                        <div class="w-100 
                        d-inline-block text-xs-center text-sm-center text-md-center">
                            <p class="text-size-14 text-white mb-0 medium-family text-full-11">
                                Developed by:<span class="text-green">MSNSOFT
                                </span>
                            </p>
                        </div>
                    </div>
                    <div class="col-xl-6 col-12 order-xl-3 order-1">
                        <div class="w-100 d-inline-block 
                        terms-service text-xs-center text-sm-center text-md-center">
                        <router-link class="text-size-13 text-white medium-family text-full-11 privacy-content" exact-active-class="active-link" to="/privacy">
                            Privacy Policy 
                            <span class="d-inline-block ms-xl-2 ms-2">I</span>
                        </router-link>
                            <router-link class="text-size-13 text-white ms-xl-2 ms-1 medium-family text-full-11 privacy-content" exact-active-class="active-link" to="/termsCondition">
                                Terms and Conditions
                                <span class="d-inline-block ms-xl-2 ms-1">I</span>
                            </router-link>
                            <router-link class="text-size-13 text-white ms-xl-2 ms-1 medium-family text-full-11 privacy-content" exact-active-class="active-link" to="/refundPolicy">
                                Return and Refund Policy
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <div  v-if="$route.path !== '/booking/' && $route.path !== '/date'"  class="w-100 d-xl-none d-block sticky-footer text-center bg-white box-shadow">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex align-items-center justify-content-between">
                            <router-link class="nav-color text-size-12 inter-regular-family fw-bold" exact-active-class="active-link" to="/">
                                <!-- <i class="fa fa-home text-size-24" aria-hidden="true"></i> -->
                                <img src="@/assets/images/home-bottom-icon.svg" alt="picture" style="height:28px;">
                                <p class="mb-0">Home</p>
                            </router-link>
                            <router-link class="nav-color text-size-12 inter-regular-family fw-bold" exact-active-class="active-link" to="/booking/">
                                <!-- <i class="fa fa-calendar text-size-24" aria-hidden="true"></i> -->
                                <img src="@/assets/images/book-online-bottom-icon.svg" alt="picture" style="height:28px;">
                                <p class="mb-0">Book Online</p>
                            </router-link>
                            <a class="nav-color text-size-12 inter-regular-family fw-bold" href="javascript:void(0)" @click="openWhatsApp">
                                <!-- <i class="fa fa-whatsapp text-black text-size-24" aria-hidden="true"></i> -->
                                <img src="@/assets/images/whatsapp-bottom-icon.svg" alt="picture" style="height:28px;">
                                <p class="mb-0">WhatsApp</p>
                            </a>
                            <!-- <a class="nav-color text-size-12 inter-regular-family fw-bold" href="javascript:void(0)" @click="openCall">
                                <img src="@/assets/images/call-bottom-icon.svg" alt="picture" style="height:28px;">
                                <p class="mb-0">Call</p>
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'footerComponent',

    data() {
       return {
        
       }
     },

methods:{

    openWhatsApp() {
        window.dispatchEvent(new CustomEvent('open-whatsapp-chat'));
  },
    async openCall() {
        // console.log("Call link clicked");
    
        // First, call the API to store the click data
        await this.callClick('call');
    
        // Then open the phone app
        const phoneNumber = "+971522809076";
        const telUrl = `tel:${phoneNumber}`;
        window.open(telUrl, "_blank");
      },  
      async callClick(method) {
    //   console.log('Call button clicked');
       try {
        const payload = {
          website_name: this.$websiteName,
          type: method,
          ip: 'call',
        
        };
        const response = await this.$axios.post('/click-count', payload);
        console.log('Response:', response.data);
        
      } catch (err) {
        console.error('Error during call click:', err);
      }
    },

}

}
</script>

<style scoped>

</style>
